/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .ck-editor__editable{min-height:calc(70vh - 165px)!important}.btnSave[_ngcontent-%COMP%]{margin-right:12px}.cursorProp[_ngcontent-%COMP%]{cursor:pointer;padding-right:1px}"];
export { styles as styles };
